import { Reveal, PageHeader } from "@/components/common/Reveal";
import { EnquiryForm } from "@/components/forms/EnquiryForm";
import { ContactDetails } from "@/components/sections/ContactDetails";

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <PageHeader testid="contact-header" label="Contact · Project enquiry" title="Tell us about your scheme"
        text="Share the project details below and our team will come back to you. Every enquiry goes straight to enquiries@rrhp.ie." />
      <section className="mx-auto grid max-w-7xl gap-16 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-12">
        <Reveal className="lg:col-span-7">
          <EnquiryForm />
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.1}>
          <ContactDetails />
        </Reveal>
      </section>
    </main>
  );
}
